// Rezumat lizibil al unui user agent, pentru evidența acceptărilor juridice.
//
// Deliberat mic și fără dependență: nu facem detecție de browser pentru a lua
// decizii de produs — șirul este deja stocat ca element probatoriu, iar aici îl
// facem doar citibil de un om care se uită la dovadă. Rezumatul nu înlocuiește
// niciodată șirul brut, care rămâne sursa de adevăr.
//
// Ordinea contează: multe browsere se dau drept altele. `Edg` conține `Chrome`,
// `Chrome` conține `Safari`, deci verificarea merge de la cel mai specific la
// cel mai generic.
const BROWSERS = Object.freeze([
  { name: "Edge", re: /Edg(?:e|A|iOS)?\/([\d.]+)/ },
  { name: "Opera", re: /OPR\/([\d.]+)/ },
  { name: "Samsung Internet", re: /SamsungBrowser\/([\d.]+)/ },
  { name: "Firefox", re: /(?:Firefox|FxiOS)\/([\d.]+)/ },
  { name: "Chrome", re: /(?:Chrome|CriOS)\/([\d.]+)/ },
  { name: "Safari", re: /Version\/([\d.]+).*Safari/ },
]);

const PLATFORMS = Object.freeze([
  { name: "Android", re: /Android\s+([\d.]+)/ },
  { name: "iPadOS", re: /iPad.*OS\s+([\d_]+)/ },
  { name: "iOS", re: /(?:iPhone|iPod).*OS\s+([\d_]+)/ },
  // Versiunea macOS este înghețată de browsere la `10_15_7` din 2020 și nu mai
  // reflectă sistemul real, deci nu o raportăm deloc.
  { name: "macOS", re: /Mac OS X/ },
  { name: "Windows", re: /Windows NT\s+([\d.]+)/ },
  { name: "Linux", re: /Linux/ },
]);

// Windows nu își spune versiunea comercială în user agent, ci numărul de kernel.
const WINDOWS_NAMES = Object.freeze({ "10.0": "10/11", "6.3": "8.1", "6.2": "8", "6.1": "7" });

const majorVersion = (value) => String(value || "").replace(/_/g, ".").split(".")[0] || "";

const describeBrowser = (userAgent) => {
  for (const browser of BROWSERS) {
    const match = browser.re.exec(userAgent);
    if (match) {
      const major = majorVersion(match[1]);
      return major ? `${browser.name} ${major}` : browser.name;
    }
  }
  return "";
};

const describePlatform = (userAgent) => {
  for (const platform of PLATFORMS) {
    const match = platform.re.exec(userAgent);
    if (!match) continue;
    if (platform.name === "Linux" || platform.name === "macOS") return platform.name;
    const version = String(match[1] || "").replace(/_/g, ".");
    if (platform.name === "Windows") {
      const label = WINDOWS_NAMES[version];
      return label ? `Windows ${label}` : "Windows";
    }
    return version ? `${platform.name} ${majorVersion(version)}` : platform.name;
  }
  return "";
};

/**
 * Întoarce ceva de forma `Chrome 141 · macOS 15`.
 *
 * Un user agent nerecunoscut nu produce niciodată o etichetă inventată: dacă nu
 * putem citi nici browserul, nici platforma, întoarcem șir gol, iar apelantul
 * afișează șirul brut. Într-o dovadă, „necunoscut" este mai onest decât un
 * rezumat greșit.
 */
export const summarizeUserAgent = (userAgent) => {
  const raw = String(userAgent || "").trim();
  if (!raw) return "";
  return [describeBrowser(raw), describePlatform(raw)].filter(Boolean).join(" · ");
};

export default summarizeUserAgent;
